import CompProCard from "@@/after_sale/pro_card.vue";
import { mdaftersaleUploadExpress, mdaftersalDetail } from "@/api/index";
import MDRouter from "@/service/router";
import { mapState, mapActions } from "vuex";
import { mdToast } from "../../utils/tools";
export default {
  components: {
    CompProCard
  },
  computed: {
    ...mapState({
      expressCompanyList: state => state.order.expressCompanyList.map(item => ({
        text: item,
        value: item
      }))
    })
  },
  data() {
    return {
      aftersale_id: '',
      order_id: '',
      express_no: '',
      // 物流单号
      express_company: '',
      // 物流公司
      pro_info: {},
      showPop: false,
      selectedValues: [],
      loading: true
    };
  },
  async mounted() {
    const query = this.$route.query;
    this.aftersale_id = query.aftersale_id;
    this.order_id = query.order_id;

    // 通过 aftersale_id 和 order_id 重新获取完整的售后信息
    await this.getAftersaleInfo();

    // 获取物流公司列表
    if (this.expressCompanyList.length == 0) {
      this.GetExpressCompanyList();
    }
  },
  methods: {
    ...mapActions(['GetExpressCompanyList']),
    // 获取售后详情信息
    async getAftersaleInfo() {
      try {
        const {
          status,
          data,
          message
        } = await mdaftersalDetail({
          aftersale_id: this.aftersale_id,
          order_id: this.order_id
        });
        if (status == 0 && data) {
          const {
            pro_info
          } = data;
          // 从接口直接获取 pro_info，避免 URL 传参乱码
          this.pro_info = {
            pro_id: (pro_info === null || pro_info === void 0 ? void 0 : pro_info.id) || '',
            name: (pro_info === null || pro_info === void 0 ? void 0 : pro_info.name) || '',
            url: (pro_info === null || pro_info === void 0 ? void 0 : pro_info.logo2) || ''
          };
        } else {
          mdToast(message || '获取售后信息失败');
        }
      } catch (error) {
        console.error('获取售后信息失败', error);
        mdToast('获取售后信息失败');
      } finally {
        this.loading = false;
      }
    },
    showList() {
      this.showPop = true;
    },
    confirm({
      selectedValues
    }) {
      this.express_company = selectedValues[0];
      this.showPop = false;
    },
    uploadExpress() {
      if (this.express_no && this.express_company) {
        mdaftersaleUploadExpress({
          aftersale_id: this.aftersale_id,
          express_no: this.express_no,
          express_company: this.express_company
        }).then(res => {
          if (res.status == 0) {
            MDRouter.GoBack();
          } else {
            mdToast(res.message);
          }
        });
      }
    }
  }
};